import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function InquiryForm({ defaultDress = "" }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    dress_ref: defaultDress,
    wish_date: "",
    message: "",
  });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Bitte Name und Telefonnummer angeben.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/inquiries", form);
      setSent(true);
      toast.success("Anfrage gesendet");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div data-testid="inquiry-success" className="p-10 border border-[#E5E0D8] bg-white text-center">
        <div className="overline mb-3 text-gold">Vielen Dank</div>
        <h3 className="font-display text-3xl md:text-4xl mb-4">Deine Anfrage ist bei uns angekommen.</h3>
        <p className="text-ink/70 max-w-md mx-auto">
          Danke! Deine Anfrage wurde gesendet. Wir melden uns so schnell wie möglich bei dir.
        </p>
      </div>
    );
  }

  return (
    <form data-testid="inquiry-form" onSubmit={submit} className="space-y-6">
      <Field label="Name" id="inq-name">
        <input
          id="inq-name"
          data-testid="inquiry-name"
          value={form.name}
          onChange={onChange("name")}
          className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none transition-colors"
          placeholder="Vor- und Nachname"
          required
        />
      </Field>
      <div className="grid md:grid-cols-2 gap-6">
        <Field label="Telefonnummer" id="inq-phone">
          <input
            id="inq-phone"
            data-testid="inquiry-phone"
            value={form.phone}
            onChange={onChange("phone")}
            className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none transition-colors"
            placeholder="+49 ..."
            required
          />
        </Field>
        <Field label="Kleidnummer / Kleidname" id="inq-dress">
          <input
            id="inq-dress"
            data-testid="inquiry-dress"
            value={form.dress_ref}
            onChange={onChange("dress_ref")}
            className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none transition-colors"
            placeholder="z. B. Kleid 03 oder Red Queen"
          />
        </Field>
      </div>
      <Field label="Wunschdatum" id="inq-date">
        <input
          id="inq-date"
          data-testid="inquiry-date"
          type="date"
          value={form.wish_date}
          onChange={onChange("wish_date")}
          className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none transition-colors"
        />
      </Field>
      <Field label="Nachricht" id="inq-msg">
        <textarea
          id="inq-msg"
          data-testid="inquiry-message"
          value={form.message}
          onChange={onChange("message")}
          rows={4}
          className="w-full bg-transparent border-b border-[#E5E0D8] focus:border-ink py-3 outline-none transition-colors resize-none"
          placeholder="Hier kannst du uns weitere Details mitteilen..."
        />
      </Field>

      <button
        data-testid="inquiry-submit"
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center bg-ink text-cream px-10 py-4 text-xs tracking-widest uppercase hover:bg-gold transition-colors duration-300 disabled:opacity-50"
      >
        {loading ? "Wird gesendet..." : "Anfrage senden"}
      </button>
    </form>
  );
}

function Field({ label, id, children }) {
  return (
    <div>
      <label htmlFor={id} className="overline block mb-1">{label}</label>
      {children}
    </div>
  );
}
